import { useEffect } from 'react';
import { ContextualSaveBarProps } from '@shopify/polaris';
import { useApp } from '@context/app';

const useSaveBar = (props: ContextualSaveBarProps, deeps: any[] = []) => {
  const { discardAction } = props;
  const { setShowSave, updateSaveBar } = useApp();
  useEffect(() => {
    updateSaveBar &&
      updateSaveBar({
        alignContentFlush: true,
        fullWidth: true,
        ...props,
        discardAction,
        saveAction: {
          ...props.saveAction,
          onAction: () => {
            props.saveAction?.onAction && props.saveAction?.onAction();
          },
        },
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deeps]);
  return {
    showSaveBar: setShowSave,
  };
};

export default useSaveBar;
